// removed by extract-text-webpack-plugin
module.exports = {"ingredientLabel":"G2f891c","button":"Ge9cc01"};